import { render, staticRenderFns } from "./KnowDialog.vue?vue&type=template&id=67179314&scoped=true&"
import script from "./KnowDialog.vue?vue&type=script&lang=ts&"
export * from "./KnowDialog.vue?vue&type=script&lang=ts&"
import style0 from "./KnowDialog.vue?vue&type=style&index=0&id=67179314&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67179314",
  null
  
)

export default component.exports